'use client';
import { ComponentSharedJotForm } from '@peerless/data-access/strapi';
import { useEffect, useId, useRef } from 'react';
import { withSectionLayout } from './SectionLayout';
import { SectionHeader } from './SectionHeader';
import { isValidUrl } from '../utils';
import { useTranslations } from 'next-intl';
import { Alert } from '@mui/material';

interface Props {
  data: ComponentSharedJotForm;
}
export function _JotForm({ data }: Props) {
  const t = useTranslations();
  const { formId: formUrl, sectionHeader } = data;
  const containerRef = useRef<HTMLDivElement>(null);
  const formId = useId();
  useEffect(() => {
    const script = document.createElement('script');
    script.id = formId;
    script.type = 'text/javascript';
    script.async = true;
    script.src = formUrl;
    if (!document.getElementById(formId)) {
      containerRef.current?.appendChild(script);
    }
  }, [formId, formUrl]);

  if (!isValidUrl(formUrl))
    return (
      <Alert variant="outlined" severity="error">
        {t('Error.jot-form-not-found')}
      </Alert>
    );

  return (
    <>
      <SectionHeader {...sectionHeader} />
      <div ref={containerRef}></div>
    </>
  );
}

export const JotForm = withSectionLayout(_JotForm);
